import { loginLoading, currentUser } from '../store/store.js';

export class User {
    constructor({accessToken, type, numberOfAnalysis, username, stripe_customer_id, subscription_current_period_end, subscription_status, subscription_tier, first_name, last_name}) {
        this.accessToken = accessToken;
        this.type = type;
        this.numberOfAnalysis = numberOfAnalysis;
        this.username = username;
        this.stripe_customer_id = stripe_customer_id;
        this.subscription_current_period_end = subscription_current_period_end;
        this.subscription_status = subscription_status;
        this.subscription_tier = subscription_tier;
        this.first_name = first_name;
        this.last_name = last_name;
    }
}

export async function handleLogin(username, loginPassword) {
    loginLoading.set(true);

    try {
        const formData = new URLSearchParams();
        formData.append('username', username);
        formData.append('password', loginPassword);

        const response = await fetch('https://boanalys-backend-324523837899.europe-north1.run.app/token', {
            method: 'POST',
            credentials: 'include', // Important for receiving cookies
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: formData,
        });

        if (!response.ok) {
            console.error(`Inloggning misslyckades: ${response.statusText}`);
            currentUser.set(null);
            localStorage.removeItem('currentUser'); // Clear any stale data
            throw new Error(`Inloggning misslyckades.`);
        }

        const data = await response.json();
        if (!data.access_token) {
            throw new Error('No access token received');
        }

        const tokenPayload = parseJwt(data.access_token);

        const userObj = new User({
            accessToken: data.access_token,
            type: tokenPayload.type,
            numberOfAnalysis: tokenPayload.number_of_analysis,
            username: tokenPayload.sub,
            stripe_customer_id: tokenPayload.stripe_customer_id,
            subscription_current_period_end: tokenPayload.subscription_current_period_end,
            subscription_status: tokenPayload.subscription_status,
            subscription_tier: tokenPayload.subscription_tier,
            first_name: tokenPayload.first_name,
            last_name: tokenPayload.last_name
        });

        // Store in localStorage for persistence
        localStorage.setItem('currentUser', JSON.stringify(userObj));

        currentUser.set(userObj);

        window.scrollTo(0, 0);
    } catch (error) {
        console.error("Ett fel uppstod vid inloggning.");
    } finally {
        loginLoading.set(false);
    }
}

export async function handleGoogleLogin(res) {
    // Process the response, send credential to backend, etc.
    const authResponse = await fetch('https://boanalys-backend-324523837899.europe-north1.run.app/auth/google', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ credential: res.credential })
    });
    
    if (!authResponse.ok) {
        console.error(`Inloggning misslyckades: ${authResponse.statusText}`);
        currentUser.set(null);
        localStorage.removeItem('currentUser'); // Clear any stale data
        throw new Error(`Inloggning misslyckades.`);
    }
    
    const data = await authResponse.json();
    const accessToken = data.access_token;
    if (!accessToken) {
        throw new Error('No access token received');
    }
    
    const tokenPayload = parseJwt(accessToken);
    
    // Create user object
    const userObj = new User({
        accessToken: accessToken,
        type: tokenPayload.type,
        numberOfAnalysis: tokenPayload.number_of_analysis,
        username: tokenPayload.sub,
        stripe_customer_id: tokenPayload.stripe_customer_id,
        subscription_current_period_end: tokenPayload.subscription_current_period_end,
        subscription_status: tokenPayload.subscription_status,
        subscription_tier: tokenPayload.subscription_tier,
        first_name: tokenPayload.first_name,
        last_name: tokenPayload.last_name
    });
    
    // Store in localStorage for persistence
    if (typeof localStorage !== 'undefined') {
        localStorage.setItem('currentUser', JSON.stringify(userObj));
    }
    
    // Update the store
    currentUser.set(userObj);
}

export function parseJwt(token) {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    } catch (e) {
        return null;
    }
}

export async function handleLogout() {
    try {
        console.log("Logging out...");
        
        // First, clear client-side storage
        localStorage.removeItem('currentUser');
        console.log("Cleared localStorage");
        
        // Clear the user from the store immediately for responsive UI
        currentUser.set(null);
        
        // Then call the server to clear the cookie
        const response = await fetch('https://boanalys-backend-324523837899.europe-north1.run.app/logout', {
            method: 'GET',
            credentials: 'include',
            redirect: 'manual',
        });
        
        if (response.type === 'opaqueredirect') {
            console.log("Server logout request sent. Server is expected to clear the cookie and redirect.");
        } else if (response.ok) {
            console.log("Server logout successful");
        } else {
            console.error(`Server logout request failed or returned non-ok status: ${response.status} ${response.statusText}`);
        }
        
        // Redirect to home page
        window.location.href = '/';
        
    } catch (error) {
        console.error('Error during logout operation:', error);
        
        if (typeof browser !== 'undefined' && browser) {
            localStorage.removeItem('currentUser');
        }
        currentUser.set(null);
        
        // Redirect to home page even on error
        window.location.href = '/';
    }
}